import { Context, Effect } from "effect";
import type { Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { WorkflowMutationAction, WorkflowMutationSnapshot, WorkflowMutationSettlement } from "./mutation-model.ts";
export interface WorkflowMutationSession { readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<WorkflowMutationSnapshot>>; readonly dispatch: (action: WorkflowMutationAction) => Effect.Effect<void> }
export class WorkflowMutations extends Context.Service<WorkflowMutations, {
  readonly open: Effect.Effect<WorkflowMutationSession, never, Scope.Scope>;
  readonly pending: Atom.Atom<AsyncResult.AsyncResult<readonly string[]>>;
  readonly settlements: Effect.Effect<readonly WorkflowMutationSettlement[]>;
}>()("workerstation/frontend/WorkflowMutations") {}
